import { Sparkles } from "lucide-react";

/**
 * HotelBrandCorner — hotel logo + IC Bingo mark in the top-left corner.
 * Uses whatever logoUrl is set in the hotel branding profile.
 */
export default function HotelBrandCorner({ hotel }) {
  return (
    <div
      data-testid="projector-brand-corner"
      className="flex items-center gap-3 ic-font-display"
    >
      <div
        className="rounded-xl flex items-center justify-center border overflow-hidden"
        style={{
          width: "clamp(3rem, 4vw, 5rem)",
          height: "clamp(3rem, 4vw, 5rem)",
          background: "var(--ic-bg-elevated)",
          borderColor: "var(--ic-border-subtle)",
          boxShadow: "0 0 24px var(--ic-primary-glow)",
        }}
      >
        {hotel?.logoUrl ? (
          <img
            src={hotel.logoUrl}
            alt={hotel.name}
            className="max-w-[70%] max-h-[70%] object-contain"
          />
        ) : (
          <Sparkles
            className="w-6 h-6"
            style={{ color: "var(--ic-primary)" }}
            strokeWidth={2}
          />
        )}
      </div>
      <div className="flex flex-col leading-none">
        <span
          className="text-[10px] tracking-[0.4em] uppercase"
          style={{ color: "var(--ic-text-muted)" }}
        >
          IC Bingo
        </span>
        <span
          className="font-bold mt-1"
          style={{
            fontSize: "clamp(1rem, 1.4vw, 1.4rem)",
            color: "var(--ic-text-primary)",
          }}
        >
          {hotel?.name || "Your Hotel"}
        </span>
      </div>
    </div>
  );
}
